import React, { useState } from "react";
import type { View } from "../../types";
import { useBilling } from "../../store/BillingContext";
import { useAuth } from "../../store/AuthContext";

export const MobileNav: React.FC = () => {
  const { view, setView, state, openNewDocument } = useBilling();
  const { user, logout } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const mainTabs: [View, string, string][] = [
    ["dashboard", "Home", "fa-chart-pie"],
    ["invoices", "Invoices", "fa-file-invoice-dollar"],
    ["accounting", "Accounting", "fa-scale-balanced"],
    ["expenses", "Expenses", "fa-wallet"],
  ];

  const moreItems: [View, string, string][] = [
    ["quotations", "Quotations & Estimates", "fa-file-lines"],
    ["clients", "Clients Directory", "fa-users"],
    ["services", "Services & Rates", "fa-box-open"],
    ["settings", "Agency Settings", "fa-gear"],
  ];

  const isMoreActive = moreItems.some(([v]) => v === view);

  return (
    <>
      {/* Mobile Top App Bar */}
      <div className="mobile-top-bar">
        <div className="mobile-brand" onClick={() => setView("dashboard")}>
          <img src="/logo.png" alt="Logo" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          <div>
            <b>Revival <em>Softech</em></b>
            <small>Billing Hub</small>
          </div>
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <button
            className="mobile-quick-add primary"
            onClick={() => openNewDocument("invoice")}
            title="Create Invoice"
          >
            <i className="fa-solid fa-plus" /> Invoice
          </button>
          <button
            className="mobile-menu-btn"
            onClick={() => setDrawerOpen(true)}
            aria-label="Open Navigation Drawer"
          >
            <i className="fa-solid fa-bars" />
          </button>
        </div>
      </div>

      {/* Mobile Slide-Out Drawer */}
      {drawerOpen && (
        <div className="mobile-drawer-overlay" onClick={() => setDrawerOpen(false)}>
          <div className="mobile-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-drawer-header">
              <div className="mobile-brand">
                <img src="/logo.png" alt="Logo" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                <div>
                  <b>Revival <em>Softech</em></b>
                  <small>Billing Hub</small>
                </div>
              </div>
              <button
                className="mobile-drawer-close"
                onClick={() => setDrawerOpen(false)}
              >
                ×
              </button>
            </div>

            <div className="mobile-drawer-body">
              <div className="drawer-section-label">Main Views</div>
              {mainTabs.map(([v, label, icon]) => (
                <button
                  key={v}
                  className={`drawer-item ${view === v ? "active" : ""}`}
                  onClick={() => {
                    setView(v);
                    setDrawerOpen(false);
                  }}
                >
                  <i className={`fa-solid ${icon}`} />
                  <span>{label}</span>
                  {v === "invoices" && state.invoices.length > 0 && (
                    <span className="drawer-badge">{state.invoices.length}</span>
                  )}
                  {v === "quotations" && state.quotes.length > 0 && (
                    <span className="drawer-badge">{state.quotes.length}</span>
                  )}
                  {v === "clients" && state.clients.length > 0 && (
                    <span className="drawer-badge">{state.clients.length}</span>
                  )}
                </button>
              ))}

              <div className="drawer-section-label" style={{ marginTop: "16px" }}>Management & Config</div>
              {moreItems.map(([v, label, icon]) => (
                <button
                  key={v}
                  className={`drawer-item ${view === v ? "active" : ""}`}
                  onClick={() => {
                    setView(v);
                    setDrawerOpen(false);
                  }}
                >
                  <i className={`fa-solid ${icon}`} />
                  <span>{label}</span>
                </button>
              ))}
            </div>

            <div className="mobile-drawer-footer">
              <div className="drawer-status">
                <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, minWidth: 0 }}>
                  <span className="dot" />
                  <div style={{ minWidth: 0, overflow: "hidden" }}>
                    <b style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", display: "block" }}>
                      {user?.email || "revivalsoftech@gmail.com"}
                    </b>
                    <small>Active Session</small>
                  </div>
                </div>
                <button
                  className="mobile-sign-out-btn"
                  onClick={() => {
                    setDrawerOpen(false);
                    logout();
                  }}
                  title="Sign Out"
                >
                  <i className="fa-solid fa-arrow-right-from-bracket" />
                  <span>Exit</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Bottom Navigation Bar */}
      <nav className="mobile-bottom-bar">
        {mainTabs.map(([v, label, icon]) => {
          const isActive = view === v;
          let count = 0;
          if (v === "invoices") count = state.invoices.length;
          if (v === "quotations") count = state.quotes.length;

          return (
            <button
              key={v}
              className={`bottom-tab ${isActive ? "active" : ""}`}
              onClick={() => setView(v)}
            >
              <div style={{ position: "relative" }}>
                <i className={`fa-solid ${icon}`} />
                {count > 0 && <span className="tab-bubble">{count}</span>}
              </div>
              <span>{label}</span>
            </button>
          );
        })}

        <button
          className={`bottom-tab ${isMoreActive ? "active" : ""}`}
          onClick={() => setDrawerOpen(true)}
        >
          <i className="fa-solid fa-ellipsis" />
          <span>More</span>
        </button>
      </nav>
    </>
  );
};
